/**
 * Helper to determine the next test screen based on selected types
 * and which tests have already been completed
 */

import type { FertilityTestingState } from "./FertilityTestingContext";

export type TestType =
  | "urine"
  | "imaging"
  | "sampling"
  | "genetic"
  | "blood"
  | "semen"
  | "other";
export type ScreenName =
  | "UrineTests"
  | "ImagingTests"
  | "SamplingTests"
  | "GeneticTests"
  | "BloodTests"
  | "FertilityTestingComplete";

const testTypeToScreen: Partial<Record<TestType, ScreenName>> = {
  urine: "UrineTests",
  imaging: "ImagingTests",
  sampling: "SamplingTests",
  genetic: "GeneticTests",
  blood: "BloodTests",
};

/**
 * Builds a navigation stack based on selected test types
 */
export function buildNavigationStack(selectedTypes: string[]): string[] {
  const testOrder: TestType[] = [
    "urine",
    "imaging",
    "sampling",
    "genetic",
    "blood",
  ];

  const stack: string[] = [];

  for (const testType of testOrder) {
    if (selectedTypes.includes(testType)) {
      const screen = testTypeToScreen[testType];
      if (screen) {
        stack.push(screen);
      }
    }
  }

  stack.push("FertilityTestingComplete");
  return stack;
}

/**
 * Gets the next screen from the navigation stack
 */
export function getNextTestScreen(state: FertilityTestingState): ScreenName {
  const { navigationStack = [], currentNavigationIndex = 0 } = state;

  if (currentNavigationIndex >= navigationStack.length) {
    return "FertilityTestingComplete";
  }

  return navigationStack[currentNavigationIndex] as ScreenName;
}
